
import * as QuillNamespace from 'quill';
const Quill: any = QuillNamespace;
const Clipboard = Quill.import('modules/clipboard');

export class PlainClipboard extends Clipboard {
  onPaste (e) {
    e.preventDefault();
  }
}
